module.exports = {
    AIRCRAFT_WRAPPER_CLASS: 'od-aircraftmap-map-wrapper',
    AIRCRAFT_SEAT_CLASS: 'od-aircraftmap-seat',
    AIRCRAFT_NO_SEAT_CLASS: 'od-aircraftmap-noseat',
    BLANK_SEATS: -1,
    BLANK_SPACE: ' ',
    CABINS_CLASS: 'od-aircraftmap-cabin',
    CHEAPER_TYPE: 'smart',
    COLOR_SEAT_GENERIC_CLASS: 'odf-icon odf-icon-xl odf-text-center odf-col odf-col-nogutter od-seat-color aircraftmap_seat',
    COLOR_SEAT_ROW_CLASS: 'od-row-seat-color',
    COLOR_SEAT_CABIN_CLASS: 'od-cabin-color',
    COLUMN_REFERENCE_CLASS: 'od-column-reference',
    EMPTY_ROW: -2,
    EXTRA_ICON_CLASS: 'odf-icon-x-leg-room',
    EXTRA_JS_CLASS: 'aircraftmap_extra_leg_room',
    EXTRA_OD_CLASS: 'od-aircraftmap-extra-leg-room',
    EXTRA_LEG: 'EXTRA_LEG',
    EXTRA_LEG_TYPE: 'extra',
    LAVATORY: 'LAVATORY',
    NO_SEATS: 0,
    PREFERRED_ICON_CLASS: 'odf-icon-crown',
    PREFERRED_JS_CLASS: 'aircraftmap_preferred_seat',
    PREFERRED_OD_CLASS: 'od-aircraftmap-preferred-seats',
    PREFERRED_TYPE: 'preferred',
    ROW_CLASS: 'od-aircraftmap-row',
    ROW_EXTRA_LEG_CLASS: 'od-aircraftmap-row-extra-leg',
    ROW_REFERENCE_CLASS: 'od-row-reference',
    SEAT_AISLE_CLASS: 'od-aircraftmap-aisle',
    SMART_ICON_CLASS: 'odf-icon-tag',
    SMART_JS_CLASS: 'aircraftmap_cheaper_seat',
    SMART_OD_CLASS: 'od-aircraftmap-default-seat-cheapest',
    STANDARD_ICON_CLASS: '',
    STANDARD_JS_CLASS: 'aircraftmap_default_seat',
    STANDARD_TYPE: 'standard',
};
